import { render, staticRenderFns } from "./CouponServiceList.vue?vue&type=template&id=8700d54a&scoped=true"
import script from "./CouponServiceList.vue?vue&type=script&lang=js"
export * from "./CouponServiceList.vue?vue&type=script&lang=js"
import style0 from "./CouponServiceList.vue?vue&type=style&index=0&id=8700d54a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8700d54a",
  null
  
)

export default component.exports